import pt from './locales/pt';
import type { Dictionary } from './locales/pt';

/**
 * O dicionário do idioma atual, acessível de fora do React.
 *
 * `useCopy()` cobre componentes, mas nem todo texto nasce num componente:
 * `src/data/projectTemplates.ts` semeia o primeiro projeto do usuário e é
 * consumido por serviço, não por tela. Sem isto, ou a assinatura dessas
 * funções carregaria o dicionário em cada chamada (contaminando todo call
 * site), ou o projeto semeado sairia em português para um usuário que escolheu
 * inglês.
 *
 * Mesmo padrão já usado em `format.ts` para o locale de formatação: o
 * `LocaleProvider` grava aqui durante a renderização, antes de qualquer filho.
 *
 * Não use isto em componente. Em componente é `useCopy()`, que reage à troca
 * de idioma; este valor é um retrato do momento da chamada.
 */
let currentCopy: Dictionary = pt;

export function setCurrentCopy(copy: Dictionary): void {
  currentCopy = copy;
}

export function getCurrentCopy(): Dictionary {
  return currentCopy;
}
